const toggletipButton = "_toggletipButton_1f603_3";
const toggletipTrigger = "_toggletipTrigger_1f603_23";
const toggletipIcon = "_toggletipIcon_1f603_39";
const toggletipTriggerIconHidden = "_toggletipTriggerIconHidden_1f603_44";
const toggletipPopover = "_toggletipPopover_1f603_50";
const toggletipArrow = "_toggletipArrow_1f603_63";
const styles = {
  toggletipButton,
  toggletipTrigger,
  toggletipIcon,
  toggletipTriggerIconHidden,
  toggletipPopover,
  toggletipArrow,
  "toggletip-default-icon": "_toggletip-default-icon_1f603_69",
  "toggletip-default-active": "_toggletip-default-active_1f603_77",
  "toggletip-default-text": "_toggletip-default-text_1f603_85",
  "toggletip-inverted-icon": "_toggletip-inverted-icon_1f603_91",
  "toggletip-inverted-active": "_toggletip-inverted-active_1f603_99",
  "toggletip-inverted-text": "_toggletip-inverted-text_1f603_107"
};
export {
  styles as s
};
